import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Slider from "react-slick";
// import { dashboardApi, dashboardURL, baseUrl } from "../utils/apiActions/dashboardApi";
import logo from "../assets/img/logo.png";

const Newsflash = () => {

//   const settings = {
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 2,
//     arrows: false,
//     dots: false,
//     autoplay: true,
//     autoplaySpeed: 1,
//     speed: 10000,
//     cssEase: "linear",
//     variableWidth: true,
//     pauseOnHover: true,
//   };
  return (
    <></>
//     <div className='col-md-12 newsFlash-Wrap'>
//       <div className='ms-panel newsFlash-Cont'>
//         <div className='ms-panel-body ms-news-flash-container'>
//           <div
//             className='ms-news-update newsFlash-Text_Bg'
//             style={{ backgroundColor: "#eee" }}
//           >
//             {/* <span>Welcome</span> */}
//             <nav>
//               <img src={logo} alt='' className='landingPage-Nav-Logo mb-1' />
//             </nav>
//           </div>
//           {/* <Slider id='news-flash' {...settings}>
//             {news.map((item, i) => (
//               <li key={i}>
//                 <p style={{ marginLeft: "10em" }}>{item.title}</p>
//               </li>
//             ))}
//             <p style={{ marginLeft: "10em" }}>
//               Security Fees Collection System &nbsp; &nbsp;
//             </p>
//           </Slider> */}
//         </div>
//       </div>
//     </div>
  );
};

export default Newsflash;
